import {FormBuilderAnswerableAdvancedDropdown, FormBuilderQuestion} from "@/types";
import {ExclamationCircleIcon} from '@heroicons/react/20/solid'
import AnswerableTextField from "@/Components/FormViewer/AnswerableTextField";
import {useEffect, useState} from "react";

interface Props {
    question: FormBuilderQuestion,
    hasError: boolean
}

export default function AnswerableAdvancedDropdown<T extends { answerable: FormBuilderAnswerableAdvancedDropdown }>({
                                                                                                                        question,
                                                                                                                        data,
                                                                                                                        setData,
                                                                                                                        hasError,
                                                                                                                        settings
                                                                                                                    }: Props) {
    const [localValue, setLocalValue] = useState('');
    useEffect(() => {
        const value: string = !data[question.id] ? "" : data[question.id];
        console.log('value', value, data[question.id])
        const dropdownValue: string = (Object.keys(question.answerable.options).includes(value)) ? value : '_OTHER_';
        setLocalValue(value)
    })
    // check if the default is null and convert it to a string because React doesn't like null

    console.log('localValue', localValue)

    return (
        <div className="relative mt-1">
            <select
                value={localValue}
                onChange={(e) => {
                    setLocalValue(e.target.value);
                    setData(question.id, (e.target.value == '_OTHER_') ? '' : e.target.value)
                }}
                id={`${question.id}-target`}
                aria-describedby={`${question.id}-description`}
                required={"is_required" in question.answerable ? question.answerable.is_required : false}
                className={`mt-1 block w-full rounded-md border-gray-100 py-2 pl-3 pr-10 text-base text-gray-600 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed focus:border-[${settings.primaryColour}] focus:ring-[${settings.primaryColour}] sm:text-sm`}
            >
                <option value=""></option>
                {Object.keys(question.answerable.options).map((o) => {
                    return (<option key={o} value={o}>{question.answerable.options[o]}</option>);
                })}
                {(question.answerable.allow_other_answer ? <option value={"_OTHER_"}>Other</option> : <></>)}
            </select>
            {otherAnswer(question, data, setData, localValue, hasError, settings)}


            {(hasError) ? (errorBadge()) : (<></>)}
        </div>
    )
        ;

}

function errorBadge() {
    return (<div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
        <ExclamationCircleIcon className="h-5 w-5 text-red-500" aria-hidden="true"/>
    </div>)
}

function otherAnswer(question: FormBuilderQuestion, data, setData, value, hasError: boolean, settings) {
    console.log('settings', settings)
    if (question.answerable.allow_other_answer && value == '_OTHER_') {
        return <AnswerableTextField question={question} data={data} setData={setData}
                                    hasError={hasError} settings={settings}/>
    } else {
        return <></>
    }
}
